import { OrderHistory, OrderItem, OrderScheduleLines } from './../../../api/models/project-summary';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ProjectService } from '../../../api/services/project.services';
import { Task } from '../../../api/models/task';
import { ProjectSummary, ProjectOrderInput,  ProjectOrderSummaryFilter } from '../../../api/models/project-summary';
import { Project } from '../../../api/models/project-model';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { TasksService } from '../../../api/services/tasks.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UserService } from '../../../api/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { MarketService } from '../../../api/services/market.service';
@Component({
  selector: 'app-project-order-summary',
  templateUrl: './project-order-summary.component.html',
  styleUrls: ['./project-order-summary.component.scss']
})
export class ProjectOrderSummaryComponent implements OnInit {
  tasks: Task[];
  loading = true;
  showNoOrdersMessage = false;
  noOrdersMessage = ['There are no orders to display for this project.'];
  noOrdersMessageWithTarget;
  projectSummary: ProjectSummary = new ProjectSummary();
  project: Project;
  isExpandAll : boolean = false;
  target = 'all';
  targetNameAlias ='all';
  errorMessage: string[] = [];
  @ViewChild('accordion') accordion: NgbAccordion;
  showTextSearchField : boolean = true;
  selectedDateValue: any;
  showPOSummarySearchOption = false;
  searchTextValue:string;
  placeholder : string = 'Enter search value';
  poSummaryFilterOptions = [{
    "poSummaryFilterKey": "PONumber"
    }, {
        "poSummaryFilterKey": "OrderNumber"
    },
    {
        "poSummaryFilterKey": "ReqDeliveryDate"
    }, {
        "poSummaryFilterKey": "POEntryDate"
    }, {
        "poSummaryFilterKey": "Sku"
    },
    {
        "poSummaryFilterKey": "PartNumber"
    },
    {
      "poSummaryFilterKey": "Description"
    }

  ];
  projectOrderSummaryKey : string;
  projectOrderSummarySearchValue : string;
  blob: any;
  excelBtnDisabled: boolean = false;
  projectOrderInput: ProjectOrderInput;
  projOrderSummaryFilter: ProjectOrderSummaryFilter;

  sortDirection: string;
  poEntryDateSortDirection = '';
  poNumberSortDirection = '';
  orderNumberSortDirection = '';
  statusSortDirection = '';
  requestedDeliveryDate = '';

  tempOrders: OrderHistory[];

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private location: Location,
    private router: Router,
    private tasksService: TasksService,
    private userService: UserService,
    private toastr: ToastrService,
    private marketService: MarketService
  ) { }

  ngOnInit() {
    this
      .route
      .params
      .subscribe(params => {
        this.projectService.getProjectById(params.id, false, false).subscribe(project => {
          if (this.userService.isMarketPermittedForCurrentUser(project.marketId)) {
            this.project = project;
            this.target = params.target;
            this.setTargetName(this.target);
              forkJoin(
                this.tasksService.getTasksByProject(this.project.name, this.project.accountNumber),
                this.projectService.getProjectOrderSummaryV2(new ProjectOrderInput(this.project.name, this.project.accountNumber, "", localStorage.getItem("marketLocationCode")))
              ).subscribe(result => {
                this.tasks = result[0];
                this.projectSummary = result[1];
                this.loading = false;
                this.showPOSummarySearchOption = true;
                if(!this.projectSummary || ! this.projectSummary.orders || this.projectSummary.orders.length < 1) {
                  this.showNoOrdersMessage = true;
                  this.showPOSummarySearchOption = false;
                } else {
                  //This does a deep copy of the array
                  this.tempOrders = JSON.parse(JSON.stringify(this.projectSummary.orders));
                  if (this.tasks.length) {
                    this.tasks.forEach(task => {
                      this.populateTasksForROG(task);
                    });
                  }
                }
                if (this.target !== 'all') {
                  let filteredOrderHistory: OrderHistory[] = [];
                  var orderHistoryResponse = result[1];
                  orderHistoryResponse.orders.forEach(orderHistoryData => {
                      let onTargetSkus: OrderItem[] = [];
                      let OffTargetSkus: OrderItem[] = [];
                      let shippedSkus: OrderItem[] = [];
                      let deliveredSkus: OrderItem[] = [];
                      orderHistoryData.orderItems.forEach(orderItem => {
                        if (orderItem.isSkuOnTarget) {
                          onTargetSkus.push(orderItem);
                        } else if (orderItem.itemDeliveryDetails && orderItem.itemDeliveryDetails.length > 0) {
                          if (orderItem.itemDeliveryDetails.every(itemDel => itemDel.podStatus === '01')) {
                            deliveredSkus.push(orderItem);
                          } else {
                            shippedSkus.push(orderItem);
                          }
                        } else {
                          if (!orderItem.isParentItem) {
                            OffTargetSkus.push(orderItem);
                          }
                        }
                      });
                      switch (this.target) {
                        case 'onTarget':
                          if (onTargetSkus.length > 0) {
                            orderHistoryData.orderItems = [];
                            orderHistoryData.orderItems = onTargetSkus;
                            filteredOrderHistory.push(orderHistoryData);
                          }
                          break;

                        case 'offTarget':
                          if (OffTargetSkus.length > 0) {
                            orderHistoryData.orderItems = [];
                            orderHistoryData.orderItems = OffTargetSkus;
                            filteredOrderHistory.push(orderHistoryData);
                          }
                          break;
                        
                        case 'shipped':
                          orderHistoryData.orderItems = [];
                          orderHistoryData.orderItems = shippedSkus;
                          filteredOrderHistory.push(orderHistoryData);
                          break;
                      
                        case 'delivered':
                          orderHistoryData.orderItems = [];
                          orderHistoryData.orderItems = deliveredSkus;
                          filteredOrderHistory.push(orderHistoryData);
                          break;
                      
                        default:
                          orderHistoryData.orderItems = [];
                          orderHistoryData.orderItems = OffTargetSkus;
                          filteredOrderHistory.push(orderHistoryData);
                          break;
                      }
                  });
                  this.projectSummary.orders = filteredOrderHistory.filter(o => o.orderItems.length > 0);
                  
                  if (this.projectSummary.orders.length < 1) {
                    if(this.tempOrders.length<1){
                      this.showNoOrdersMessage = true;
                      this.showPOSummarySearchOption = false;
                    }else{
                      this.showNoOrdersMessage = true;
                      let msg = '';
                      if (this.targetNameAlias == 'Shipped' || this.targetNameAlias == 'Delivered') {
                        msg = ' No orders in this project have been ' + this.targetNameAlias + ' yet.';
                      } else {
                        msg = 'There are currently no orders within this project, with status ' + this.targetNameAlias+'.';
                      }
                      this.noOrdersMessage = [msg];
                      this.showPOSummarySearchOption = false;
                    }
                  
                  }
              }
            });
          } else {
            this.project = null;
            this.loading = false;
            this.errorMessage.push("You don't have permission to view this page!!!");
          }
        }, error => {
          this.loading = false;
          this.project = null;
          this.errorMessage.push(error.error.message);
        });
      });
  }

  private setTargetName(targetName) {
    if (targetName == "onTarget") {
      this.targetNameAlias = "On-Target";
    } else if (targetName == "offTarget") {
      this.targetNameAlias = "Off-Target";
    }
    else if (targetName == "shipped") {
      this.targetNameAlias = "Shipped";
    } else if (targetName == "delivered") {
      this.targetNameAlias = "Delivered";
    }
  }

  private populateTasksForROG(task: Task) {
    if (task.taskType === 'RECEIPT OF GOODS' && task.opened) {
      if (this.projectSummary.orders.find(order => order.salesOrderNumber === task.orderNumber)) {
        this.projectSummary.orders.find(order => order.salesOrderNumber === task.orderNumber).tasks = [];
        this.projectSummary.orders.find(order => order.salesOrderNumber === task.orderNumber).tasks.push(task);
      }
    }
  }

  isOpened(index: number) {
    const id = `ngb-panel-${index + 1}`;
    return this.accordion.activeIds.includes(id);
  }

  goToOrderConfirmation(orderNumber: string) {
    this.router.navigate(['/dashboard',
      {
        outlets: {
          'dashboard-content': ['order-confirmation',
            this.project.name, this.project.accountNumber, orderNumber]
        }
      }]);
    return false;
  }

  goBack(): void {
    this.location.back();
  }

  expandCollapseAll() {
    if (this.isExpandAll) {
      this.isExpandAll = false;
      this.accordion.activeIds=[];
    } else {
      this.isExpandAll = true;
      if (this.projectSummary.orders && this.projectSummary.orders.length) {
        let activeIds : string[] =[];
        this.projectSummary.orders.forEach((order, index) => {
          activeIds.push(`ngb-panel-${index + 1}`);
        })
        this.accordion.activeIds = activeIds;
      }
    }
  }

  onEnteringSearchValue(value) {
    this.projectOrderSummarySearchValue = value;
  }

  onDateSelect(event) {
  let year = event.year;
  let month = event.month <= 9 ? '0' + event.month : event.month;
  let day = event.day <= 9 ? '0' + event.day : event.day;
  let finalDate = year +"-"+ month + "-" + day;
  this.projectOrderSummarySearchValue = finalDate;
 }

selectPOSummarySearchOption(event: any) {
  this.projectOrderSummaryKey = event.target.value;
  if (this.projectOrderSummaryKey == 'ReqDeliveryDate' ||
      this.projectOrderSummaryKey == 'POEntryDate') {
      this.showTextSearchField = false;
  } else {
      this.showTextSearchField = true;
  }
  switch (this.projectOrderSummaryKey) {
    case 'PONumber': this.placeholder = 'Enter PO Number';
    break;
    case 'OrderNumber': this.placeholder = 'Enter Order Number';
    break;
    case 'Sku': this.placeholder = 'Enter SKU';
    break;
    case 'PartNumber': this.placeholder = 'Enter Part Number';
    break;
    case 'Description': this.placeholder = 'Enter Description';
    break;
    default: this.placeholder = 'Enter Search Value';
    break;
  }
  this.projectOrderSummarySearchValue = '';
  this.searchTextValue = '';
  this.selectedDateValue='';
}

  filterPOSummary() {
    if (this.projectOrderSummaryKey == null || this.projectOrderSummarySearchValue.length === 0) {
      this.projectOrderInput = new ProjectOrderInput(this.project.name, this.project.accountNumber, "", localStorage.getItem("marketLocationCode"));
    } else {
      this.projectOrderInput = new ProjectOrderInput(this.project.name, this.project.accountNumber, "", localStorage.getItem("marketLocationCode"));
      this.projOrderSummaryFilter = new ProjectOrderSummaryFilter(this.projectOrderSummaryKey, this.projectOrderSummarySearchValue);
      this.projectOrderInput.poSummaryFilter = this.projOrderSummaryFilter;
      this.projOrderSummaryFilter.isCallFromUI = true;
    }
    this.loading = true;
    forkJoin(
      this.tasksService.getTasksByProject(this.project.name, this.project.accountNumber),
      this.projectService.getProjectOrderSummaryV2(this.projectOrderInput)
    ).subscribe(result => {
      this.tasks = result[0];
      this.projectSummary = result[1];
      this.loading = false;
      if (!this.projectSummary.orders.length) {
        this.showNoOrdersMessage = true;
        this.showPOSummarySearchOption = true;
        this.showPOSummarySearchOption = true;
      } else {
        this.showNoOrdersMessage = false;
        this.showPOSummarySearchOption = true;
        this.showPOSummarySearchOption = true;
        if (this.tasks.length) {
          this.tasks.forEach(task => {
            this.populateTasksForROG(task);
          });
        }
      }

    });
  }

  sortPOEntryDate() {
    if (this.poEntryDateSortDirection === '') {
      this.poEntryDateSortDirection = 'asc';
    } else if (this.poEntryDateSortDirection === 'asc') {
      this.poEntryDateSortDirection = 'desc';
    } else {
      this.poEntryDateSortDirection = '';
    }
    this.sortDirection = this.poEntryDateSortDirection;
    this.poNumberSortDirection = '';
    this.orderNumberSortDirection = '';
    this.statusSortDirection = '';
    this.requestedDeliveryDate = '';
  }

  sortPONumber() {
    if (this.poNumberSortDirection === '') {
      this.poNumberSortDirection = 'asc';
    } else if (this.poNumberSortDirection === 'asc') {
      this.poNumberSortDirection = 'desc';
    } else {
      this.poNumberSortDirection = '';
    }
    this.sortDirection = this.poNumberSortDirection;
    this.poEntryDateSortDirection = '';
    this.orderNumberSortDirection = '';
    this.statusSortDirection = '';
    this.requestedDeliveryDate = '';
  }

  sortOrderNumber() {
    if (this.orderNumberSortDirection === '') {
      this.orderNumberSortDirection = 'asc';
    } else if (this.orderNumberSortDirection === 'asc') {
      this.orderNumberSortDirection = 'desc';
    } else {
      this.orderNumberSortDirection = '';
    }
    this.sortDirection = this.orderNumberSortDirection;
    this.poEntryDateSortDirection = '';
    this.poNumberSortDirection = '';
    this.statusSortDirection = '';
    this.requestedDeliveryDate = '';
  }

  sortStatus() {
    if (this.statusSortDirection === '') {
      this.statusSortDirection = 'asc';
    } else if (this.statusSortDirection === 'asc') {
      this.statusSortDirection = 'desc';
    } else {
      this.statusSortDirection = '';
    }
    this.sortDirection = this.statusSortDirection;
    this.poEntryDateSortDirection = '';
    this.poNumberSortDirection = '';
    this.orderNumberSortDirection = '';
    this.requestedDeliveryDate = '';
  }

  sortReqDeliveryDate() {
    if (this.requestedDeliveryDate === '') {
      this.requestedDeliveryDate = 'asc';
    } else if (this.requestedDeliveryDate === 'asc') {
      this.requestedDeliveryDate = 'desc';
    } else {
      this.requestedDeliveryDate = '';
    }
    this.sortDirection = this.requestedDeliveryDate;
    this.poEntryDateSortDirection = '';
    this.poNumberSortDirection = '';
    this.orderNumberSortDirection = '';
    this.statusSortDirection = '';
  }

  sortColumns(n: number){
    if (n == 1) {
      this.sortPOEntryDate();
    } else if (n == 2) {
      this.sortPONumber();
    } else if (n == 3) {
      this.sortOrderNumber();
    } else if (n == 4) {
      this.sortStatus();
    } else if (n == 5) {
      this.sortReqDeliveryDate();
    }
  }

  sortTable(n: number) {
    this.sortColumns(n);
    var tempSortDir = this.sortDirection;
    if (this.sortDirection === '') {
      this.projectSummary.orders = JSON.parse(JSON.stringify(this.tempOrders));
    }
    if (this.projectSummary.orders && this.projectSummary.orders.length) {
      var orderArray = this.projectSummary.orders
      orderArray.sort(function (a, b) {
        let keyA, keyB;
        if (n == 1) {
          keyA = new Date(a.customerPODate);
          keyB = new Date(b.customerPODate);
        } else if (n == 2) {
          keyA = a.poNumber;
          keyB = b.poNumber;
        } else if (n == 3) {
          keyA = a.salesOrderNumber;
          keyB = b.salesOrderNumber;
        } else if (n == 4) {
          keyA = a.status.toLowerCase();
          keyB = b.status.toLowerCase();
        } else if (n == 5) {
          keyA = new Date(a.reqDeliveryDate);
          keyB = new Date(b.reqDeliveryDate);
        }
        if (tempSortDir == 'asc') {
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        } else if (tempSortDir == 'desc') {
          if (keyA < keyB) return 1;
          if (keyA > keyB) return -1;
          return 0;
        }
      });
      this.projectSummary.orders = orderArray;
    }
  }

  downloadXls() {
    this.loading = true;
    if (this.projectOrderSummaryKey == null || this.projectOrderSummarySearchValue.length === 0) {
      this.projectOrderInput = new ProjectOrderInput(this.project.name, this.project.accountNumber, "", localStorage.getItem("marketLocationCode"));
    } else {
      this.projectOrderInput = new ProjectOrderInput(this.project.name, this.project.accountNumber, "", localStorage.getItem("marketLocationCode"));
      this.projOrderSummaryFilter = new ProjectOrderSummaryFilter(this.projectOrderSummaryKey, this.projectOrderSummarySearchValue);
      this.projectOrderInput.poSummaryFilter = this.projOrderSummaryFilter;
    }
    this.excelBtnDisabled = true;
    this.projectService.downloadProjectOrderSummary(this.projectOrderInput).subscribe((resp) => {
      const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'PO_Summary_' + new Date();
      const data = resp.body;
      this.blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName + '.xlsx';
      link.click();
      this.loading = false;
      this.excelBtnDisabled = false;
    }, error => {
      this.onError("Error downloading the file!!!");
      this.loading = false;
      this.excelBtnDisabled = false;
    });
  }

 private onError(msg: string) {
    this.toastr.error(msg, 'Error!', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right'
    });
  }

  shouldApplyBorder(scheduleLine: OrderScheduleLines, length: number): boolean {
    return length > 0 &&
           (scheduleLine.expectedShipDate === 'Pending MFG Date'
            || scheduleLine.expectedShipDate === 'Pending Confirmation'
            || scheduleLine.expectedShipDate.includes("Shipped -")
            || scheduleLine.expectedShipDate.includes("Est. Avail.-"));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-order-summary/project-order-summary.component.ts